import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { CzMaxPrice } from '~/Api/User/ProductGroup/CzMaxPrice';
import { selectCzechExFactoryPrice } from '~/CzMaxPrice/reducer';
import { formatPercentage } from '~/libs/Intl';

import Calculation from './Calculation';

const memoizedSelectCzechExFactoryPrice = memoizeOne(selectCzechExFactoryPrice);

interface OwnProps {
	czMaxPrice: CzMaxPrice;
}

function mapStateToProps(_: Record<never, never>, props: OwnProps) {
	const { czMaxPrice } = props;
	return {
		czechExFactoryPrice: memoizedSelectCzechExFactoryPrice(czMaxPrice),
		formatPercentage,
	};
}

export default connect(mapStateToProps)(Calculation);
